import { render, staticRenderFns } from "./Developers.vue?vue&type=template&id=0b6ae8df&"
import script from "./Developers.vue?vue&type=script&lang=js&"
export * from "./Developers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports